import { AddressInterface } from 'common/address.interface';

/*
 * Action Types
 */
export enum TransportCardsPlaceTypes {
  LIST_TRANSPORT_CARDS_PLACE_REQUEST = '@transportCardsPlace/LIST_TRANSPORT_CARDS_PLACE_REQUEST',
  LIST_TRANSPORT_CARDS_PLACE_SUCCESS = '@transportCardsPlace/LIST_TRANSPORT_CARDS_PLACE_SUCCESS',
  LIST_TRANSPORT_CARDS_PLACE_FAILURE = '@transportCardsPlace/LIST_TRANSPORT_CARDS_PLACE_FAILURE',

  GET_TRANSPORT_CARDS_PLACE_REQUEST = '@transportCardsPlace/GET_TRANSPORT_CARDS_PLACE_REQUEST',
  GET_TRANSPORT_CARDS_PLACE_SUCCESS = '@transportCardsPlace/GET_TRANSPORT_CARDS_PLACE_SUCCESS',
  GET_TRANSPORT_CARDS_PLACE_FAILURE = '@transportCardsPlace/GET_TRANSPORT_CARDS_PLACE_FAILURE',

  FILTER_TRANSPORT_CARDS_PLACE_REQUEST = '@transportCardsPlace/FILTER_TRANSPORT_CARDS_PLACE_REQUEST',
  FILTER_TRANSPORT_CARDS_PLACE_SUCCESS = '@transportCardsPlace/FILTER_TRANSPORT_CARDS_PLACE_SUCCESS',
  FILTER_TRANSPORT_CARDS_PLACE_FAILURE = '@transportCardsPlace/FILTER_TRANSPORT_CARDS_PLACE_FAILURE',

  CREATE_TRANSPORT_CARDS_PLACE_REQUEST = '@transportCardsPlace/CREATE_TRANSPORT_CARDS_PLACE_REQUEST',
  CREATE_TRANSPORT_CARDS_PLACE_SUCCESS = '@transportCardsPlace/CREATE_TRANSPORT_CARDS_PLACE_SUCCESS',
  CREATE_TRANSPORT_CARDS_PLACE_FAILURE = '@transportCardsPlace/CREATE_TRANSPORT_CARDS_PLACE_FAILURE',

  UPDATE_TRANSPORT_CARDS_PLACE_REQUEST = '@transportCardsPlace/UPDATE_TRANSPORT_CARDS_PLACE_REQUEST',
  UPDATE_TRANSPORT_CARDS_PLACE_SUCCESS = '@transportCardsPlace/UPDATE_TRANSPORT_CARDS_PLACE_SUCCESS',
  UPDATE_TRANSPORT_CARDS_PLACE_FAILURE = '@transportCardsPlace/UPDATE_TRANSPORT_CARDS_PLACE_FAILURE',

  DELETE_TRANSPORT_CARDS_PLACE_REQUEST = '@transportCardsPlace/DELETE_TRANSPORT_CARDS_PLACE_REQUEST',
  DELETE_TRANSPORT_CARDS_PLACE_SUCCESS = '@transportCardsPlace/DELETE_TRANSPORT_CARDS_PLACE_SUCCESS',
  DELETE_TRANSPORT_CARDS_PLACE_FAILURE = '@transportCardsPlace/DELETE_TRANSPORT_CARDS_PLACE_FAILURE',
}

/*
 * Data types
 */

export interface TransportCardInterface {
  id: string;
  type: number;
  status: number;
  number: string;
  lot: string;
  userId: string;
  code: string;
  transportOperatorId: string;
  placeId: string;
  createdAt: string;
  updatedAt: string;
}

export interface TransportCardPlaceAddressInterface extends AddressInterface {
  latitude: string | null;
  longitude: string | null;
  TransportCardPlaceAddress: {
    id: string;
    placeId: string;
    addressId: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface TransportSupervisorInterface {
  id: string;
  name: string;
  email: string;
  photoUrl: string;
  createdAt: string;
  updatedAt: string;
}

export interface TransportCardPlaceInterface {
  id: string;
  name: string;
  supervisorId: string;
  transportOperatorId: string;
  TransportCards: TransportCardInterface[];
  Addresses: TransportCardPlaceAddressInterface[];
  TransportSupervisor: TransportSupervisorInterface;
  createdAt: string;
  updatedAt: string;
}

/*
 * State type
 */
export interface TransportCardsPlaceState {
  readonly transportCardsPlaceList: TransportCardPlaceInterface[];
  readonly transportCardsPlaceData: TransportCardPlaceInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
